<div
    class="bazis-container bh-hide-print"
    *transloco="let t"
>
    <ng-container
        *ngIf="{
            text: textSettings$ | async,
            role: role$ | async,
            agencyContract: agencyContract$ | async,
            organization: organization$ | async,
        } as data"
    >
        <ng-container
            *ngIf="
                data.role !== ROLE.anonymous &&
                notificationsToShow['requisites'] &&
                data.text &&
                data.text['requisites'] &&
                data.organization?.$snapshot?.status?.id !== 'accepted'
            "
            [ngTemplateOutlet]="notificationTpl"
            [ngTemplateOutletContext]="{
                id: 'requisites',
                routerLink: '/profile/personal-info',
                text: data.text['requisites'],
            }"
        ></ng-container>
        <ng-container
            *ngIf="
                (data.role === ROLE.transporter ||
                    data.role === ROLE.landfill ||
                    data.role === ROLE.landfillDirector ||
                    data.role === ROLE.landfillLawyer) &&
                notificationsToShow['agencyContract'] &&
                data.text &&
                data.text['agencyContract'] &&
                data.agencyContract !== undefined &&
                data.agencyContract?.$snapshot?.status?.id !== 'accepted'
            "
            [ngTemplateOutlet]="notificationTpl"
            [ngTemplateOutletContext]="{
                id: 'agencyContract',
                routerLink: '/profile/personal-info',
                text: data.text['agencyContract'],
            }"
        ></ng-container>
    </ng-container>
</div>

<ng-template
    #notificationTpl
    let-id="id"
    let-text="text"
    let-textParams="textParams"
    let-routerLink="routerLink"
>
    <div
        *transloco="let t"
        class="bazis-block bazis-block_warning bh-margin-bottom-4x"
    >
        <bazis-icon
            color="warning"
            name="exclamation"
            size="large"
        ></bazis-icon>
        <div class="bh-flex bh-justify-content-between">
            <div class="bazis-block__content">
                <p class="bh-no-margin">
                    <span [innerHTML]="t('topNotifications.' + id + '.' + text, textParams)"></span>
                    <app-open-entity
                        *ngIf="routerLink"
                        type="link"
                        linkSize="compact"
                        class="bh-margin-start-2x"
                        [href]="routerLink"
                    >
                    </app-open-entity>
                </p>
            </div>

            <bazis-button
                size="compact"
                fill="clear"
                (click)="hideNotification(id)"
            >
                <bazis-icon
                    slot="icon-only"
                    name="cross"
                ></bazis-icon>
            </bazis-button>
        </div>
    </div>
</ng-template>
